import React from 'react'
import ServicesContent from '../ServicesContent'

function Services() {
  return (
    <>
        <ServicesContent/>
    </>
  )
}

export default Services